import styled from "styled-components";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px;
  background-color: #ffffff;
  margin: 0 auto;
  border-radius: 4px;

  form {
    max-height: calc(100vh - 4rem);
    display: flex;
    flex-direction: column;
  }
`;

export const ModalBody = styled.div`
  overflow-y: scroll;
  width: 100%;
  padding: 40px;

  h2 {
    color: #271946;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 24px;
    text-align: center;
  }
`;

export const ModalFooter = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 12px;

  @media screen and (max-width: 576px) {
    flex-direction: column;

    > * {
      width: 100%;
    }
  }
`;
